import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const StyledContainer = styled(Container)(({ theme }) => ({
  padding: '1rem',
  backgroundColor: theme.palette.background.primary
}));

const NoContent = (props) => {
  const { infoType, infoMessage } = props;

  return (
    <StyledContainer>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <InfoOutlinedIcon sx={{ mr: 3 }} />
        <Typography sx={{ fontSize: '14px' }}>{infoType}</Typography>
      </Box>

      {infoMessage && <Typography>{infoMessage}</Typography>}
    </StyledContainer>
  );
};
export default NoContent;
